import {
  SHIFTS_COUNT_EXAMPLE,
  TOTAL_WORK_HOURS_SCRIPT_EXAMPLE,
  VACATIONS_DAYS_COUNT_EXAMPLE,
  WORKING_HOURS_DEVIATION_EXAMPLE,
} from '@constants'

export const getObjectXColumnExamples = () => {
  return [
    TOTAL_WORK_HOURS_SCRIPT_EXAMPLE,
    SHIFTS_COUNT_EXAMPLE,
    VACATIONS_DAYS_COUNT_EXAMPLE,
    WORKING_HOURS_DEVIATION_EXAMPLE,
  ]
}
